var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('background-image: ' + _vm.backgroundImage +'; --font-size: ' + _vm.fontSize + ';'),attrs:{"id":"app"}},[(_vm.configLoaded)?_c('router-view'):_c('the-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }